import SubmitItem from "./Products/SubmitItem";
import SelectPayment from "./Products/SelectPayment";
import List from "./List";
import Detail from "./Detail";
import Search from "./Search";
import CheckOut from "./Products/CheckOut";
import OrderTrack from "./Products/OrderTrack";

export default {
  List,
  Detail,
  Search,
  SubmitItem,
  CheckOut,
  SelectPayment,
  OrderTrack
};
